module.exports = __webpack_public_path__ + "static/img/76107F_4_C_20230802_fit.acd52a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/76107F_4_C_20230802_fit.png
// module id = tdoN
// module chunks = 0